export const GET_SIGN_REWARD = "GET_SIGN_REWARD";

export const CLOSE_DIALOGUE_SIGN_REWARD = "CLOSE_DIALOGUE_SIGN_REWARD";

export const CREATE_SIGN_REWARD = "CREATE_SIGN_REWARD";

export const UPDATE_SIGN_REWARD = "UPDATE_SIGN_REWARD";

export const DELETE_SIGN_REWARD = "DELETE_SIGN_REWARD";

export const OPEN_DIALOGUE_SIGN_REWARD = "OPEN_DIALOGUE_SIGN_REWARD";
